<!--  -->
<template>
  <!--  -->
  <div class="prview_box">
    <div v-if="typestring == 'index'" style="display: flex;align-items: center;justify-content: center;">
      <el-button
        type="info"
        size="mini"
        :disabled="show===8"
        icon="el-icon-arrow-left"
        @click="prev"
      />
    </div>

    <div :class="[type == 1 ? 'tybox' : '']">
      <div v-if="typestring == 'index'&&contenttitle!==''" style="text-align: center;background-color: rgb(249, 251, 180);margin: 10px;border-radius: 5px;padding: 5px;">{{ contenttitle }}</div>
      <div :class="type === 1 ? 'phoner_boxone' : 'phoner_box'">
        <div class="all_boxr">
          <div class="content_box" v-html="content" />
          <div v-for="item,index in attachments" :key="index" class="at_box">
            <div v-if="item.msgtype === 'image'" class="onebox">
              <!-- <div class="swr">图片</div> -->
              <img v-if="item.msgtype === 'image' && item.image && item.image.source_material_id!=='' && item.image.source_material_id!==null" :src="item.image.pic_url" style="width:80px;height:80px;margin:10px 0px 0px 23px">
            </div>
            <div v-if="item.msgtype === 'link'" class="onebox">
              <!-- <div class="swr">图文</div> -->
              <div v-if="item.msgtype === 'link' && item.link && item.link.title!==''&& item.link.title!==null" class="within_box">
                <div class="title_boxr">{{ item.link.title }}</div>
                <div class="imaetext se_top">
                  <div class="describe_text">{{ item.link.desc }}</div>
                  <div>
                    <img v-if="linkCoverUrl(item.link)" style="width:50px;height:50px;object-fit: contain;" :src="linkCoverUrl(item.link)">
                  </div>
                </div>
              </div>
            </div>
            <div v-if="item.msgtype === 'miniprogram'" class="onebox">
              <!-- <div class="swr">小程序</div> -->
              <div v-if="item.msgtype === 'miniprogram' && item.miniprogram && item.miniprogram.title!=='' && item.miniprogram.title!==null">
                <div class="mincard">
                  <div class="mincard_title" style="display: flex;align-items: center;">
                    <img :src="item.miniprogram.weappiconurl" style="width: 25px;" alt="" srcset="">
                    <div class="mincard_title" style="margin-bottom: 0px;margin-left:5px">{{ item.miniprogram.des_1 }}</div>
                  </div>
                  <div class="mincard_enjoy">{{ item.miniprogram.title }}</div>
                  <div>
                    <img v-if="item.msgtype === 'miniprogram' && item.miniprogram && item.miniprogram.thumburl!=='' && item.miniprogram.thumburl!==null" :src="item.miniprogram.thumburl" class="imgrbox">
                  </div>
                  <div class="line" />
                  <div class="bottomwr">
                    <img src="https://cdn.mdxcx.net/default/20210625/33695da2774d54929387886410828920.png%21watermark" alt="" style="width:28px;height:28px">
                    <div class="weadar">小程序</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="item.msgtype === 'sp_miniprogram'" class="onebox">
              <div v-if="item.msgtype === 'sp_miniprogram' && item.sp_miniprogram && item.sp_miniprogram.title!=='' && item.sp_miniprogram.title!==null">
                <div class="mincard">
                  <div style="display: flex;align-items: center;"><img :src="item.sp_miniprogram.weappiconurl" style="width: 25px;" alt="" srcset=""><div class="mincard_title" style="margin-bottom: 0px;margin-left:5px">{{ item.sp_miniprogram.des_1 }}</div></div>
                  <div class="mincard_enjoy">{{ item.sp_miniprogram.title }}</div>
                  <div>
                    <img v-if="item.msgtype === 'sp_miniprogram' && item.sp_miniprogram && item.sp_miniprogram.thumburl!=='' && item.sp_miniprogram.thumburl!==null" :src="item.sp_miniprogram.thumburl" class="imgrbox">
                  </div>
                  <div class="line" />
                  <div class="bottomwr">
                    <img src="https://cdn.mdxcx.net/default/20210625/33695da2774d54929387886410828920.png%21watermark" alt="" style="width:28px;height:28px">
                    <div class="weadar">小程序</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="type == 1" class="form_box">
        <div class="send_message">
          <el-alert
            title="推送客户消息"
            type="success"
            :closable="false"
            style="padding: 8px 0; text-align: center; justify-content: center;"
          />
        </div>
        <el-form label-position="right" label-width="120px">
          <el-form-item label="员工">
            <el-tag v-if="employee_name!=''" type="warning" style="margin-right:10px">{{ employee_name }}</el-tag>
            <el-button type="primary" size="mini" @click="choosestaff">选择员工</el-button>
          </el-form-item>
          <el-form-item label="客户">
            <el-tag v-if="external_name!=''" type="warning" style="margin-right:10px">{{ external_name }}</el-tag>
            <el-button :disabled="employee_no == null" type="primary" size="mini" @click="choosecustom">选择客户</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="sumbit">确定</el-button>
          </el-form-item>
        </el-form>
        <div class="send_message">
          <el-alert
            title="推送内部群消息"
            type="success"
            :closable="false"
            style="padding: 8px 100px; text-align: center;"
          />
        </div>
        <el-form label-position="right" label-width="120px">
          <el-form-item label="员工">
            <div class="staff_tags">
              <el-tag
                v-for="item in chatRobotEmployees"
                :key="item.employee_no"
                closable
                type="warning"
                style="margin-right:10px;margin-bottom:6px"
                @close="removeChatRobotEmployee(item)"
              >{{ item.name }}</el-tag>
              <el-button type="primary" size="mini" @click="chooseChatRobotStaff">选择员工</el-button>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" :loading="chatRobotSubmitting" @click="submitChatRobot">确定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div v-if="typestring == 'index'" style="display: flex;align-items: center;justify-content: center;">
      <el-button
        type="info"
        :disabled="isshow===9"
        size="mini"
        icon="el-icon-arrow-right"
        @click="next"
      />
    </div>
    <!-- <div class="bottomwr" style="margin-bottom:20px">
      <div class="box_serw">标题预览：</div>
      <div>{{ title }}</div>
    </div>
    <div class="bottomwr">
      <div>消息文本：</div>
      <div>{{ content }}</div>
    </div> -->

    <el-dialog
      title="选择员工"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :destroy-on-close="true"
    >
      <choosestaff ref="choosestaffview" @staffcallback="staffcallback" />
    </el-dialog>
    <el-dialog
      title="选择员工"
      :visible.sync="chatRobotDialogVisible"
      :append-to-body="true"
      width="900px"
    >
      <choosestaffmulti ref="choosestaffmultiview" @staffcallback="chatRobotStaffcallback" />
    </el-dialog>
    <el-dialog
      title="选择客户"
      :visible.sync="customdialogVisible"
      :append-to-body="true"
      :destroy-on-close="true"
    >
      <choosecustom ref="choosecustomview" @customcallback="customcallback" />
    </el-dialog>
  </div>
</template>

<script>
import { spWorkWechatOpStrategyDetail } from '@/api/OperationStrategy.js'
import { mptypeslist, customerMessagepush } from '@/api/sourceMaterial.js'
import choosestaff from './choosestaff.vue'
import choosestaffmulti from './choosestaffmulti.vue'
import choosecustom from './choosecustom.vue'
import { sprEnterprise, sendToChatRobot } from '@/api/officialaccount.js'
import { getLinkCoverUrl } from '@/utils/linkCovers'
export default {
  components: { choosestaff, choosestaffmulti, choosecustom },
  data() {
    return {
      attachments: [],
      programtype: [],
      title: '',
      content: '',
      type: null,
      dialogVisible: false,
      customdialogVisible: false,
      obj: {},
      employee_no: null,
      external_user_id: null,
      employee_name: '',
      external_name: '',
      chatRobotDialogVisible: false,
      chatRobotEmployees: [],
      adlist: [],
      detailList: [],
      contenttitle: '',
      typestring: '',
      currentIndex: 0,
      show: 8,
      isshow: 0,
      isFunctionExecuting: false,
      chatRobotSubmitting: false

    }
  },
  created() {

  },
  async mounted() {

  },
  methods: {
    linkCoverUrl: getLinkCoverUrl,
    async prev(e) {
      console.log('this.currentIndex:', this.currentIndex, this.adlist)
      if (this.isFunctionExecuting) {
        return // 如果函数正在执行，则直接返回
      }

      this.isFunctionExecuting = true // 设置标志位为 true，表示函数开始执行

      if (this.currentIndex > 0) {
        this.isshow = 0
        console.log('this.currentIndex:', this.currentIndex)

        const prevItem = this.adlist[this.currentIndex - 1]
        if (prevItem === undefined) {
          this.isFunctionExecuting = false // 设置标志位为 false，表示函数执行完成
          return
        }
        console.log('prevItem:', prevItem)
        const { message, day } = prevItem
        console.log('message, day:', message, day)

        try {
          const list = await sprEnterprise({ sp_message_no: message })
          if (this.currentIndex === 1) {
            this.show = 8
            this.$message({
              type: 'info',
              message: '第一条数据'
            })
          } else {
            this.$message({
              type: 'success',
              message: '数据请求成功'
            })
          }

          this.detailList = list.data
          this.title = this.detailList.title
          const newlist = [this.detailList]
          const firstMatch = this.adlist.find(a => {
            return newlist.some(v => v.sp_message_no === a.message)
          })

          if (firstMatch) {
            this.contenttitle = firstMatch.day
          }

          console.log(this.contenttitle, '111')
          this.obj = this.detailList

          if (this.detailList.content === null) {
            this.content = ''
          } else {
            this.content = this.detailList.content.replace(/\n/g, '<br>')
          }

          this.attachments = this.detailList.attachments
          this.getmptypeslist()
          this.contenttitle = day
          this.currentIndex--
        } catch (error) {
          console.log(111)
          console.error(error)
        }
      } else {
        this.show = 8
        if (e !== 2) {
          this.$message.info('左边没有数据了')
        }
      }

      this.isFunctionExecuting = false // 设置标志位为 false，表示函数执行完成
    },

    async next(e) {
      console.log('this.currentIndex:', this.currentIndex, this.adlist)
      if (this.isFunctionExecuting) {
        return // 如果函数正在执行，则直接返回
      }
      this.show = 0
      this.isFunctionExecuting = true // 设置标志位为 true，表示函数开始执行
      if (this.currentIndex + 1 < this.adlist.length) {
        this.show = 0
        const nextItem = this.adlist[this.currentIndex + 1]
        const { message, day } = nextItem
        console.log('message, day :', message, day)
        try {
          const list = await sprEnterprise({ sp_message_no: message })
          console.log('this.currentIndex :', this.currentIndex, this.adlist.length)
          if (this.currentIndex === this.adlist.length - 2) {
            this.isshow = 9
            this.$message({
              type: 'info',
              message: '最后一条数据'// 根本没进来
            })
          } else {
            this.$message({
              type: 'success',
              message: '数据请求成功'
            })
          }

          this.detailList = list.data
          this.title = this.detailList.title
          const newlist = [this.detailList]
          const firstMatch = this.adlist.find(a => {
            return newlist.some(v => v.sp_message_no === a.message)
          })
          if (firstMatch) {
            this.contenttitle = firstMatch.day
          }
          console.log(this.contenttitle, '111')
          this.obj = this.detailList
          if (this.detailList.content === null) {
            this.content = ''
          } else {
            this.content = this.detailList.content.replace(/\n/g, '<br>')
          }
          this.attachments = this.detailList.attachments
          this.getmptypeslist()
          this.contenttitle = day
          this.currentIndex++
        } catch (error) {
          console.log(111)
          console.error(error)
        }
      } else {
        this.isshow = 9
        if (e !== 2) {
          console.log('this.currentIndex:', this.currentIndex, this.adlist.length - 1)
          this.$message.info('右边没有数据了')
        }
      }

      this.isFunctionExecuting = false // 设置标志位为 false，表示函数执行完成
    },
    async send(item, type, show) {
      console.log('item:', item)
      if (type === 'index') {
        this.currentIndex = 0
        this.attachments = []
        this.contenttitle = ''
        this.typestring = type
        this.show = 0
        this.isshow = 0
        const data = await spWorkWechatOpStrategyDetail({ id: item })
        const res = data.data.message.flatMap((obj) =>
          obj.time.flatMap((timeObj) =>
            timeObj.message.map((message) => ({
              day: `第${obj.day}天 ${timeObj.timeRange}点`,
              message: message.sp_message_no
            }))
          )
        )
        // console.log('data:', res)
        this.adlist = res
        this.show = 8
        if (this.adlist.length === 1) {
          this.$message.info('只有一条数据')
          this.next(2)
        }
        const list = await sprEnterprise({ sp_message_no: res[0].message })
        this.detailList = list.data
        // console.log('list:', list)
        this.title = this.detailList.title
        console.log(' this.detailList:', this.detailList)
        const newlist = [this.detailList]
        const firstMatch = this.adlist.find(a => {
          return newlist.some(v => v.sp_message_no === a.message)
        })
        if (firstMatch) {
          this.contenttitle = firstMatch.day
        }
        console.log(this.contenttitle, '111')
        this.obj = this.detailList
        if (this.detailList.content === null) {
          this.content = ''
        } else {
          this.content = this.detailList.content.replace(/\n/g, '<br>')
        }
        this.attachments = this.detailList.attachments
        this.prev(2)
        this.getmptypeslist()
      } else {
        this.show = show
        this.title = item.title
        this.obj = item
        this.type = type
        if (item.content === null) {
          this.content = ''
        } else {
          this.content = item.content.replace(/\n/g, '<br>')
        }

        this.attachments = item.attachments
        this.getmptypeslist()
      }
    },
    // 获取小程序消息类型
    async getmptypeslist() {
      const data = await mptypeslist()
      this.programtype = data.data.types
    },
    find(id) {
      console.log('id', id)
      const indexs = this.programtype.findIndex(item => {
        // eslint-disable-next-line eqeqeq
        return item.mini_program_type == id
      })
      if (indexs === -1) {
        return ''
      } else {
        return this.programtype[indexs].type_name
      }
    },
    async sumbit() {
      console.log('this.obj', this.obj.sp_message_no, this.obj.push_method, this.employee_no, this.external_user_id)
      // eslint-disable-next-line eqeqeq
      if (this.employee_no == null || this.employee_no == '') {
        this.$message.error('请选择员工')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.external_user_id == null || this.external_user_id == '') {
        this.$message.error('请选择员工客户')
        return
      }

      const data = await customerMessagepush({
        sp_message_no: this.obj.sp_message_no,
        push_method: this.obj.push_method,
        employee_no: this.employee_no,
        external_user_id: this.external_user_id
      })
      this.$message({
        type: 'success',
        message: '操作成功!'
      })
      this.updata()
      console.log('data', data)
    },
    async submitChatRobot() {
      if (!this.chatRobotEmployees.length) {
        this.$message.error('请选择员工')
        return
      }
      if (!this.obj || !this.obj.sp_message_no) {
        this.$message.error('缺少消息编号')
        return
      }
      this.chatRobotSubmitting = true
      try {
        await sendToChatRobot({
          employee_nos: this.chatRobotEmployees.map(item => item.employee_no),
          sp_message_no: this.obj.sp_message_no
        })
        this.$message.success('操作成功!')
        this.resetChatRobotStaff()
      } catch (e) {
        // 错误提示由 request 拦截器统一处理
      } finally {
        this.chatRobotSubmitting = false
      }
    },
    choosestaff() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.choosestaffview.send(this.obj)
      })
    },
    chooseChatRobotStaff() {
      this.chatRobotDialogVisible = true
      this.$nextTick(() => {
        this.$refs.choosestaffmultiview.open(this.chatRobotEmployees)
      })
    },
    staffcallback(item) {
      this.dialogVisible = false
      this.external_user_id = null
      this.external_name = ''
      this.employee_no = item.employee_no
      this.employee_name = item.name
      console.log('item', item)
    },
    chatRobotStaffcallback(list) {
      this.chatRobotDialogVisible = false
      this.chatRobotEmployees = list
    },
    removeChatRobotEmployee(item) {
      this.chatRobotEmployees = this.chatRobotEmployees.filter(row => row.employee_no !== item.employee_no)
    },
    choosecustom() {
      this.customdialogVisible = true
      this.$nextTick(() => {
        this.$refs.choosecustomview.customsend(this.employee_no)
      })
    },
    customcallback(item) {
      this.customdialogVisible = false
      this.external_user_id = item.external_user_id
      this.external_name = item.remark
      console.log('item', item)
    },
    updata() {
      this.employee_no = null
      this.employee_name = ''
      this.external_user_id = null
      this.external_name = ''
    },
    resetChatRobotStaff() {
      this.chatRobotEmployees = []
      if (this.$refs.choosestaffmultiview) {
        this.$refs.choosestaffmultiview.resetState()
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.within_box{
  width: 190px;
  border: 1px solid #19be6b;
  height: 100%;
  padding: 8px 8px 8px 7px;
  margin-left: 23px;
  margin-top: 15px;
}
.title_boxr{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 157px;
}
.imaetext{
  display: flex;
  justify-content: space-between;
}
.se_top{
  margin-top: 14px;
}
.describe_text{
  color: #999999;
  width: 136px;
  overflow: hidden;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  height: 50px;
}
.mincard{
  width: 215px;
  height: 251px;
  border: 1px solid #ccc;
  padding: 10px;
  box-sizing: border-box;
  margin: 10px 0px 0px 23px;
}
.mincard_title{
  font-size: 12px;
  margin-bottom: 5px;
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.imgrbox{
  width: 100%;
  height: 150px;
}
.line{
  width: 100%;
  height: 1px;
  background: #999999;
  /* margin: 5px 0px; */
  margin: 3px 0px;
}
.bottomwr{
  display: flex;
  align-items: center;
}
.mincard_enjoy{
  margin-bottom: 5px;
  width: 134px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.weadar{
  margin-left: 2px;
  font-size: 12px;
}
.all_box{
  margin: 8px 0px;
  max-height: 500px;
  overflow: hidden;
  overflow-y: auto;
  width: 100%;
}
.onebox{
  display: flex;
  align-items: center;
}
.swr{
  width: 50px;
  text-align: right;
}
.prview_box{
  /* max-height: 500px;
  overflow: hidden;
  overflow-y: scroll; */
  display: flex;
}
.prview_box::-webkit-scrollbar {
  width: 0;
}
.box_serw{
  color: rgb(169, 162, 151);
  font-size: 14px;
}
.phoner_box{
    background: url('https://mp.2f.com/v2.7.2/img/iphone6.395625b9.jpg') no-repeat;
    background-size: 100% 100%;
    width: 300px;
    height: 600px;
    margin:0 auto;
    position: relative;
}
.phoner_boxone{
    background: url('https://mp.2f.com/v2.7.2/img/iphone6.395625b9.jpg') no-repeat;
    background-size: 100% 100%;
    width: 300px;
    height: 600px;
    position: relative;
}
.at_box{
  margin: 10px 0px;
}
.all_boxr{
  max-height: 365px;
  overflow-y: auto;
  position: absolute;
  top: 120px;
  padding-left: 20px;
  box-sizing: border-box;
  width: 92%;
}
::-webkit-scrollbar {
  width: 10px;
  height: 1px;
}
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #ccc;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  background: #ededed;
  border-radius: 5px;
}
.content_box{
  padding: 20px;
}
.send_message{
  text-align: center;
  width: 360px;
  font-size: 18px;
  margin-bottom: 30px;
}
.staff_tags{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.tybox{
  display: flex;
}
.prview_box{

}
.tybox{
  width:100%;
}
@media (max-width: 768px){
  .phoner_box{
    width:71vw;
  }
  .tybox {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap:10px;
  }
  .prview_box{
    justify-content:center;
  }
}
</style>
